import { useCurrentUser } from '@/user/use-current-user.query';

import { projectIdState } from '../project.state';
import {
  projectListingsDisplayModeState,
  createDisplayModeKey,
} from '../project-listing.state';

import type { ProjectListingsDisplayMode } from './project-listings';
import { useProjectListingsTabParam } from './project-listings-table/use-project-listings-tab-param';
import { useAtom, useAtomValue } from 'jotai';

export const useChangeProjectListingsDisplayMode = () => {
  const { data: user } = useCurrentUser();
  const { listingsTabParam, setListingsTabParam } =
    useProjectListingsTabParam();
  const projectId = useAtomValue(projectIdState);

  const [displayModeMap, setDisplayModeMap] = useAtom(
    projectListingsDisplayModeState,
  );

  const displayModeKey = createDisplayModeKey(
    user?.id.toString() ?? '',
    projectId ?? '',
  );

  const displayMode = displayModeMap[displayModeKey] ?? 'table';

  const toggleDisplayMode = (activeDisplayMode: ProjectListingsDisplayMode) =>
    activeDisplayMode === 'table' ? 'byStage' : 'table';

  const isStageMode = displayMode === 'byStage';

  const onDisplayModeChange = () => {
    if (isStageMode && !listingsTabParam) {
      setListingsTabParam('all');
    }

    setDisplayModeMap(prev => ({
      ...prev,
      [displayModeKey]: toggleDisplayMode(displayMode),
    }));
  };

  return {
    displayMode,
    isStageMode,
    onDisplayModeChange,
  };
};
